import "isomorphic-fetch";
import qs from "qs";
import * as errors from "./errors";
import * as httpCodes from "./httpCodes";
import config from "src/config";
import { getAccessToken, getTokenAccessLevel } from "common/auth/token";
import { getLangCode } from "../storage";
import { PREFERRED_LANGS } from "../constants";

const { FormData } = window;

const errorMappings = {
  [httpCodes.NOT_FOUND]: errors.NotFoundError,
  [httpCodes.BAD_REQUEST]: errors.BadRequestError,
  [httpCodes.UNAUTHORIZED]: errors.UnauthorizedError,
  [httpCodes.FORBIDDEN]: errors.ForbiddenError,
  [httpCodes.INTERNAL_SERVER_ERROR]: errors.InternalServerError,
};

export default class Client {
  constructor(options = {}) {
    const { apiPath = "" } = options;
    this.apiPath = apiPath;
  }

  request(resource, options = {}) {
    const { body = null, query = {}, method = "GET", noStringify, header } = options;
    const accessToken = getAccessToken();
    let langCode = PREFERRED_LANGS[0].value;
    if (!!accessToken?.length) {
      const accessLevel = getTokenAccessLevel();
      langCode = getLangCode(accessLevel === "admin");
    }

    const requestOptions = {
      method,
      headers: {
        ...header,
        "lang-code": langCode
      },
      credentials: "include",
    };

    let path = config.api.basePath + this.apiPath + "/" + resource;
    if (Object.keys(query).length > 0) {
      path += `?${qs.stringify(query)}`;
    }

    if (body !== null && typeof body === "object") {
      if (options.body instanceof FormData) {
        requestOptions.body = options.body;
      } else {
        requestOptions.body = noStringify
          ? options.body
          : JSON.stringify(options.body);
        requestOptions.headers["Content-Type"] = "application/json";
      }
    }

    if (accessToken) {
      requestOptions.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    // return axios({
    //   ...requestOptions,
    //   url: path
    // }).catch((error) => {
    //   const response = error.response;
    //   const ErrorClass = errorMappings[response.status] || errors.APIError;
    //   throw new ErrorClass({ response });
    // });
    const request = new Request(path, requestOptions);

    return fetch(request).then((response) => {
      if (response.status >= 400) {
        return response.json().then((data) => {
          const ErrorClass = errorMappings[response.status] || errors.APIError;
          throw new ErrorClass({ request, response, data });
        });
      } else {
        return response.json();
      }
    });
  }

  get(url, options = {}) {
    return this.request(url, Object.assign({ method: "GET" }, options));
  }

  patch(url, options = {}) {
    return this.request(url, Object.assign({ method: "PATCH" }, options));
  }

  post(url, options = {}) {
    return this.request(url, Object.assign({ method: "POST" }, options));
  }

  put(url, options = {}) {
    return this.request(url, Object.assign({ method: "PUT" }, options));
  }

  del(url, options = {}) {
    return this.request(url, Object.assign({ method: "DELETE" }, options));
  }
}
